export default __webpack_public_path__ + "static/card_1-47003c1d72e04077b5f2ee49c34485c8.png";